/*global ajax_object*/
jQuery(function ($) {
  function loadPosts(page = 1, initial = false) {
    let filters = {};

    let archiveWrapper = $('.archive-ajax');

    let mainTax = archiveWrapper.data('main-tax');

    let taxonomies = archiveWrapper.data('taxonomies');

    // GET CHECKED FILTERS
    $('.term-checkbox:checked').each(function () {
      let tax = $(this)
        .attr('name')
        .match(/\[(.*?)\]/)[1];

      if (!filters[tax]) {
        filters[tax] = [];
      }

      filters[tax].push($(this).val());
    });

    $.ajax({
      url: ajax_object.ajax_url,

      type: 'POST',

      data: {
        action: 'filter_posts',
        page: page,
        filters: filters,
        main_tax: mainTax,
        taxonomies: taxonomies,
        nonce: ajax_object.nonce,
      },

      beforeSend: function () {
        $('#posts-container').addClass('loading');
      },

      success: function (response) {
        // UPDATE POSTS ONLY AFTER FILTER CLICK
        if (!initial) {
          $('#posts-container').html(response.posts);
          $('#pagination-container').html(response.pagination);
        }

        // UPDATE FACETS
        if (response.facets) {
          Object.keys(response.facets).forEach(function (tax) {
            Object.keys(response.facets[tax]).forEach(function (slug) {
              let count = response.facets[tax][slug];

              // IMPORTANT FIX
              let checkbox = $(
                'input[name*="[' + tax + ']"][value="' + slug + '"]'
              );

              let checkboxWrapper = checkbox.closest('.checkbox-label');

              // HIDE ONLY EMPTY + NOT CHECKED
              if (count === 0 && !checkbox.is(':checked')) {
                checkboxWrapper.hide();
              } else {
                checkboxWrapper.show();
              }

              // UPDATE COUNTS
              let countElement = checkboxWrapper.find('.count');

              if (countElement.length) {
                countElement.text('(' + count + ')');
              }
            });
          });
        }
      },

      complete: function () {
        $('#posts-container').removeClass('loading');
      },
    });
  }

  // FILTER CHANGE
  $(document).on('change', '.term-checkbox', function () {
    loadPosts(1);
  });

  // AJAX PAGINATION
  $(document).on('click', '#pagination-container a', function (e) {
    e.preventDefault();

    let href = $(this).attr('href');

    let page = 1;

    // PRETTY URLS
    let matchPretty = href.match(/\/page\/([0-9]+)/);

    if (matchPretty) {
      page = matchPretty[1];
    } else {
      // QUERY URLS
      let matchQuery = href.match(/paged=([0-9]+)/);

      if (matchQuery) {
        page = matchQuery[1];
      }
    }

    loadPosts(page);
  });

  // FIRST LOAD
  // ONLY UPDATE FACETS
  // DO NOT RELOAD POSTS
  loadPosts(1, true);
});
